export default __webpack_public_path__ + "static/media/paypal.813c198c.svg";